import type { AllRouteEndpoints } from "../routeTypes";

export const decisioningStudioAgentsAppGroupIdDsaIdLaunch =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/launch";

// Launching promotes the agent's draft config to live, so the live use case lookup and the
// agents list both need to refetch to reflect the newly live agent.
export const decisioningStudioAgentsAppGroupIdDsaIdLaunchCacheKeys: AllRouteEndpoints[] = [
  "/offerfit/:app_group_id/use_cases/:use_case_id",
  "/decisioning_studio_agents/:app_group_id",
];
